import React from 'react';
import { useTranslation } from 'react-i18next';
import { PercentageCalculator } from '../utils/PercentageCalculator';
import classes from '../OrganizationUsagePage.module.css';

export interface SecondaryStatCardProps {
  label: string;
  value: number;
  total?: number;
}

/**
 * Displays a secondary statistic card with optional progress bar
 */
export const SecondaryStatCard: React.FC<SecondaryStatCardProps> = ({ label, value, total }) => {
  const { t } = useTranslation();
  const shouldShowTotal = total !== undefined && total > 0;
  const progressPercentage = shouldShowTotal ? PercentageCalculator.calculate(value, total) : undefined;

  return (
    <li className={classes.secondaryStatCard}>
      <p className={classes.secondaryStatHeader}>
        <span className={classes.secondaryStatValue}>{value}</span>{' '}
        {shouldShowTotal && (
          <span className={classes.secondaryStatTotal}>{t('usage.overview.of', { total })}</span>
        )}
      </p>
      <span className={classes.secondaryStatLabel}>{label}</span>
      {progressPercentage !== undefined && (
        <span aria-hidden="true" className={classes.progressBar}>
          <span className={classes.progressFill} style={{ width: `${progressPercentage}%` }} />
        </span>
      )}
    </li>
  );
};
